
namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class PsParaDialog extends Serenity.EntityDialog<PsParaRow, any> {
        protected getFormKey() { return PsParaForm.formKey; }
        protected getIdProperty() { return PsParaRow.idProperty; }
        protected getLocalTextPrefix() { return PsParaRow.localTextPrefix; }
        protected getNameProperty() { return PsParaRow.nameProperty; }
        protected getService() { return PsParaService.baseUrl; }
        protected getDeletePermission() { return PsParaRow.deletePermission; }
        protected getInsertPermission() { return PsParaRow.insertPermission; }
        protected getUpdatePermission() { return PsParaRow.updatePermission; }

        protected form = new PsParaForm(this.idPrefix);

        constructor() {
            super();

            let helpPopover = new J.HelpPopover(this.form, this.getPropertyItems(), "i-am-a-class").init();
            //helpPopover.createHelpPopoverButton(PsParaRow.Fields.AllowSaleOverStock, { content: "My content", title: "My title" });
        }
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "panel-titlebar-close"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "panel-titlebar-close::after"), 1);

            
            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );

            return buttons;
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();


            this.form.BackOfficeUpLoadURL.value = window.location.origin+"/upload/";

            var id = Q.first(Administration.CsParaRow.getLookup().items, x => x.BizName != null).Id;
            //console.log('id ='+id);
            Administration.CsParaService.Retrieve({
                EntityId: id
            }, response => {
                this.setDataDefaultCsPara(response.Entity);
            });

            this.deleteButton.hide();
            this.saveAndCloseButton.hide();
            this.cloneButton.hide();

            let self = this;
            let nbrRetry = 0;
            (function changeTitle() {
                if (nbrRetry >= 10) {
                    return;
                }

                setTimeout(() => {
                    if ((self as any).isMarkedAsPanel === true) {
                        if (self.element.find(".panel-titlebar").length == 1) {
                            // self.element.find(".panel-titlebar").html("");
                            //self.element.find(".panel-titlebar-text").html("");
                            self.element.find(".panel-titlebar-close").hide();//panel-titlebar
                        }
                        else {
                            changeTitle();
                        }
                    }
                    else {
                        if (self.element.parent().find(".panel-titlebar").length == 1) {
                            // self.element.parent().find(".panel-titlebar").html("");
                            // self.element.parent().find(".panel-titlebar-text").html("");
                            self.element.parent().find(".panel-titlebar-close").hide();
                        }
                        else {
                            changeTitle();
                        }
                    }
                }, 100);
            })();


        }

        private setDataDefaultCsPara(details: Administration.CsParaRow) {
            this.form.ShopRegName.value = details.BizName;
            this.form.ShopRegAddressLine1.value = details.BizAddressLine1;
            this.form.ShopRegAddressLine2.value = details.BizAddressLine2;
            this.form.ShopRegAddressLine3.value = details.BizAddressLine3;
            this.form.ShopRegId.value = details.RegId;
            this.form.ShopTaxId.value = details.TaxId;
        }
    }
}